import React from 'react';
//import ReactDOM from 'react-dom';
import { GraphiQL } from 'graphiql';
import { createClient } from 'graphql-ws';
//import { SubscriptionClient } from 'subscriptions-transport-ws';
//import { createClient } from 'graphql-sse';
import { createGraphiQLFetcher } from '@graphiql/toolkit';
import 'graphiql/graphiql.min.css'
// import logo from './logo.svg';
import './App.css';

const baseUrl = 'gids-graphql-api-us-east-2-alb-90452200.us-east-2.elb.amazonaws.com'

const host = window.location.host
const protocol = window.location.protocol.toLowerCase()
const wsProtocol = protocol == 'https:' ? 'wss:' : 'ws:'

const url = `${protocol}//${host}/graphql`;
const subscriptionUrl = `${wsProtocol}//${host}/graphql/socket`;
// const url = 'http://localhost:8080/graphql';
// const subscriptionUrl = 'ws://localhost:8080/graphql/socket';
// const url = 'http://localhost:8088/api/graphql';
// const subscriptionUrl = 'ws://localhost:8088/ws/graphql';

const fetcher = createGraphiQLFetcher({
  url,
  wsClient: createClient({
    url: subscriptionUrl,
    keepAlive: 2000,
  }),
  //legacyWsClient: new SubscriptionClient(subscriptionUrl),
});

function App() {

  return (

    <GraphiQL fetcher={fetcher} />
  );
}

export default App;
